import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { debounce, isEmpty, get } from 'lodash';

import { createToast, toastType } from 'Common/ToastHelper';
import { LoadingBase } from 'Components/';
import MealTypes from 'PointOfSale/modules/mealTypes/component/MealTypes';
import * as MealTypeActions from 'PointOfSale/modules/mealTypes/state/actions';
import { setSiteDatePopupOpen } from 'PointOfSale/modules/setDateAndSite/state/action';
import * as POSSelectors from 'PointOfSale/selectors';

import 'PointOfSale/styles/components/pageHeader.less';
import 'PointOfSale/styles/components/pageFooter.less';
import { getValue } from 'Common/Components/Keyboard/withKeyboard';
import { getKeyboardActive } from 'Common/UI/state/selectors';

class MealType extends Component {
  keyboardInputRef = React.createRef();

  componentDidMount() {
    if (isEmpty(this.props.selectedSiteDetails)) {
      this.props.setSiteDatePopupOpen();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.fetchError && this.props.fetchError) {
      createToast(
        toastType.error,
        'Error',
        'There was an error retrieving serving items'
      );
    }
  }

  debouncedAction = debounce((data, action) => action(data), 750);

  reset = () => {
    this.props.MealTypeActions.reset();
  };

  tabClickHandler = tab => {
    this.props.MealTypeActions.selectTabMenu(tab);
  };

  searchHandler = e => {
    const searchText = getValue(e);
    this.props.MealTypeActions.setSearchText(searchText);
  };

  editHandler = () => {};

  onKeyboardFocus = () => {
    const { keyboardActive } = this.props;

    if (keyboardActive) {
      if (
        window.matchMedia(
          'only screen and (min-width: 768px) and (max-width: 1200px) '
        ).matches
      ) {
        this.keyboardInputRef.current.wrappedInstance.adjustScreenForKeyboard();
      }
    }
  };

  save = () => {
    this.props.MealTypeActions.saveOrderNum();
  };

  areAllItemsSelected = () => {
    return this.items.length > 0 && this.items.every(i => i.selected);
  };

  get items() {
    const {
      currentSelectedMenu,
      currentSelectedTabMenu,
      filteredAllFoodItems,
    } = this.props;

    const items = get(
      filteredAllFoodItems,
      [currentSelectedMenu, currentSelectedTabMenu],
      []
    );
    return items;
  }

  areNoItemsSelected = () => {
    return this.items.length === 0 || this.items.every(i => !i.selected);
  };

  toggleSelectedItems = selected => {
    this.items.forEach(item =>
      this.props.MealTypeActions.selectFoodItem(item, selected)
    );
  };

  render() {
    const {
      tabMenus,
      searchText,
      selectedSiteDetails,
      currentSelectedMenu,
      fetching,
      saveOrderNumFetching,
    } = this.props;
    return fetching ? (
      <LoadingBase flexible />
    ) : (
      <MealTypes
        tabMenus={tabMenus}
        tabClickHandler={this.tabClickHandler}
        searchText={searchText}
        searchHandler={this.searchHandler}
        currentSelectedMenu={currentSelectedMenu}
        reset={this.reset}
        selectedSiteDetails={selectedSiteDetails}
        onKeyboardFocus={this.onKeyboardFocus}
        keyboardInputRef={this.keyboardInputRef}
        toggleSelectedItems={this.toggleSelectedItems}
        allItemsSelected={this.areAllItemsSelected()}
        noItemsSelected={this.areNoItemsSelected()}
        save={this.save}
        saving={saveOrderNumFetching}
      />
    );
  }
}

MealType.propTypes = {
  mealTypes: PropTypes.object,
  currentSelectedMenu: PropTypes.string,
  MealTypeActions: PropTypes.shape({
    reset: PropTypes.func,
  }),
};
const mapStateToProps = state => ({
  filteredAllFoodItems: POSSelectors.filteredAllFoodItems(state),
  fetching: POSSelectors.getFetching(state),
  itemCategories: POSSelectors.getItemCategories(state),
  selectedSiteDetails: POSSelectors.getSelectedSiteDetails(state),
  foodItems: POSSelectors.getFoodItems(state),
  tabMenus: POSSelectors.getSelectedMealTypesTabsMenus(state),
  currentSelectedMenu: POSSelectors.getCurrentSelectedMenu(state),
  searchText: POSSelectors.getMealTypesSearchText(state),
  fetchError: POSSelectors.getFetchError(state),
  keyboardActive: getKeyboardActive(state),
  currentSelectedTabMenu: POSSelectors.getCurrentSelectedTabMenu(state),
  saveOrderNumFetching: POSSelectors.getSaveOrderNumFetching(state),
});

const mapDispatchToProps = dispatch => ({
  setSiteDatePopupOpen: () => dispatch(setSiteDatePopupOpen()),
  MealTypeActions: bindActionCreators(MealTypeActions, dispatch),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MealType)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/mealTypes/container/index.js